import { render, staticRenderFns } from "./UpdateEntityNameCard.vue?vue&type=template&id=01bcfce6&"
import script from "./UpdateEntityNameCard.vue?vue&type=script&lang=js&"
export * from "./UpdateEntityNameCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports